const normalizeBoolean = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    return /^(true|1)$/i.test(value.trim());
  }
  return false;
};

const normalizePositiveInteger = (value) => {
  const normalized = Number(value);
  return Number.isInteger(normalized) && normalized > 0 ? normalized : null;
};

export default {
  build(payload = {}) {
    return {
      token: payload.token ?? null,
      refreshToken: payload.refreshToken ?? null,

      idUser: payload.idUser ?? payload.guid ?? null,
      idCompany: payload.idCompany ?? null,
      idProfile: payload.idProfile ?? payload.guidProfile ?? null,
      guidProfile: payload.guidProfile ?? null,
      idCatType: payload.idCatType ?? null,
      isEmployee: normalizeBoolean(payload.isEmployee),
      idEmployee: normalizePositiveInteger(payload.idEmployee),
      activeCompanyGuid:
        payload.activeCompanyGuid ?? payload.guidCompany ?? null,
      profileName: payload.profileName ?? null,
      companyType: payload.companyType ?? null,
      idCatCoinType: payload.idCatCoinType ?? null,
      nameCoinType: payload.nameCoinType ?? null,
      iva: payload.iva ?? null,
      statusSuscription: payload.statusSuscription ?? null,
      nameSuscription: payload.nameSuscription ?? null,
      fechaInicioSuscription: payload.fechaInicioSuscription ?? null,
      fechaFinSuscription: payload.fechaFinSuscription ?? null,
      dolarBCV: payload.dolarBCV ?? null,
      tasaDolar: payload.tasaDolar ?? null,
      photo: payload.photo ?? null,
      famcos: Boolean(payload.famcos),
      menuPermissions: payload.menuPermissions ?? [],
      features: payload.features ?? [],

      createdAt: Date.now(),
    };
  },
};
